module.exports = ng.material.icon;